// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__1ee8i","price":"styles_price__AcAhI","controls":"styles_controls__nhva2","next":"styles_next__CoHMk","draft":"styles_draft__bLDFj"};